import { Component, EventEmitter, inject, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { VariablesGlobalesService } from 'src/app/services/variables-globales.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EncriptarService } from 'src/app/services/encriptar.service';
import { CategoriaDTO } from 'src/app/Models/ApiV2/CategoriaDTO';
import { FamiliaArticuloDTO } from 'src/app/Models/ApiV2/FamiliaArticuloDTO';
import { MarcaDTO } from 'src/app/Models/ApiV2/MarcaDTO';
import { ArticuloDTO, TarifaDescuentosDTO, TarifaPreciosDTO, TipoTarifaDTO } from 'src/app/Models/ApiV2/ArticuloDTO';
import { AMRespuestaGET } from 'src/app/Models/RespuestaGET/AMRespuestaGET';
import { ErpService } from 'src/app/services/API_ALO/erp.service';
import { enumNivelDetalle, eTipoGrupo } from 'src/GlobalConf';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { db } from 'src/db/db';
import { GridComponent, KENDO_GRID, PageChangeEvent, PageSizeItem, SelectAllCheckboxState } from '@progress/kendo-angular-grid';
import { SortDescriptor } from '@progress/kendo-data-query'
import { ProcesosGlobalesService } from 'src/app/services/procesos-globales.service';
import { LlamadasAlertsService } from 'src/app/services/llamadas-alerts.service';
import { BuscarFiltrosArticulosPipe } from '../lista-articulos/pipesarticulo/buscarFiltrosArticulos.pipe';
import { BuscarArticuloPipe } from '../lista-articulos/pipesarticulo/buscarArticulo.pipe';

import { addIcons } from 'ionicons';
import { funnelOutline, funnel, listOutline, gridOutline,add,closeCircle, refresh,alertCircleOutline, close, trendingDown, addCircle,swapVertical,options } from 'ionicons/icons';
import { ModalController, IonInfiniteScroll, LoadingController , AlertController, Platform, IonInfiniteScrollContent,
        IonGrid, IonRow,IonCol,IonLabel,IonSearchbar,IonButton,
        IonIcon,IonBadge,IonItem,IonToggle,IonSegment, IonChip,IonSegmentButton,
        IonProgressBar,IonRefresher,IonRefresherContent,IonItemSliding,IonCard,IonCardHeader,
        IonCardContent,IonAvatar,IonItemOptions,IonItemOption,IonImg,IonModal,IonHeader,IonToolbar,
        IonButtons,IonContent,IonAccordion,IonAccordionGroup,IonFooter,IonCardSubtitle,IonInput,
        } from '@ionic/angular/standalone';

interface CategoriaSeleccion {
  categoriaArticulo: CategoriaDTO;
  seleccionada: boolean;
}

interface FamiliaSeleccion {
  familiasArticulos: FamiliaArticuloDTO;
  seleccionada: boolean;
}

interface MarcaSeleccion {
  marcaArticulo: MarcaDTO;
  seleccionada: boolean;
}


@Component({
  selector: 'app-lista-articulos',
  templateUrl: './lista-articulos.component.html',
  styleUrls: ['./lista-articulos.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [BuscarArticuloPipe, BuscarFiltrosArticulosPipe, TitleCasePipe],
  standalone: true,
  imports: [IonInfiniteScrollContent, IonInfiniteScroll, CommonModule, TranslateModule, KENDO_GRID,
    IonGrid, IonRow, IonCol, IonLabel, IonSearchbar,IonButton, IonIcon, IonBadge, IonItem, IonToggle,
    IonSegment, IonSegmentButton, IonChip, IonProgressBar, IonRefresher, IonRefresherContent, IonItemSliding,
    IonCard, IonCardHeader, IonCardContent, IonAvatar, IonItemOptions, IonItemOption, IonImg, IonModal,
    IonHeader, IonToolbar, IonButtons, IonContent, IonAccordion , IonAccordionGroup, IonFooter,
    IonCardSubtitle, IonInput],

})
export class ListaArticulosComponent implements OnInit {
  private pipeBuscarFiltrosArticulos = inject(BuscarFiltrosArticulosPipe);
  private pipeBuscarArticulo = inject(BuscarArticuloPipe);
  variablesGlobales = inject(VariablesGlobalesService);
  translate = inject(TranslateService);
  alertCtrl = inject(AlertController);
  servicioEncriptar = inject(EncriptarService);
  private servicioErp = inject(ErpService);
  private loadingCtrl = inject(LoadingController);
  private titlecasePipe = inject(TitleCasePipe);
  platform = inject(Platform);
  procesosGlobales = inject(ProcesosGlobalesService);
  llamadasService = inject(LlamadasAlertsService);
  private modalCtrl = inject(ModalController);

  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  @ViewChild(GridComponent) grid: GridComponent;
  @Input() selectorArticulo: boolean
  @Input() articulos: ArticuloDTO[];
  @Output() articuloSeleccionado = new EventEmitter<ArticuloDTO>();
  @Output() actualizarListaArticulos = new EventEmitter()
  articulosCompleto: ArticuloDTO[];
  articulosRecientes: ArticuloDTO[];
  articulosFiltrados: ArticuloDTO[] = [];
  articulosMostrar: ArticuloDTO[] = [];
  articulosMostrarKendo: ArticuloDTO[] = [];


  categoriasArticulos: CategoriaSeleccion[] = [];
  categoriasArticulosSeleccionadas: CategoriaDTO[] = [];

  familiasArticulos: FamiliaSeleccion[] = [];
  familiasArticulosSeleccionadas: FamiliaArticuloDTO[] = [];

  marcasArticulos: MarcaSeleccion[] = [];
  marcasArticulosSeleccionadas: MarcaDTO[] = [];

  tarifasPrecio: TipoTarifaDTO[] = [];
  tarifaPrecioVentaPredeterminada: TipoTarifaDTO = null
  tarifaPrecioCompraPredeterminada: TipoTarifaDTO = null
  tarifasDescuentos: TipoTarifaDTO[] = [];
  tarifaDescuentoPredeterminada: TipoTarifaDTO = null
  numFiltros: number = 0; variables: any;
  loading: boolean;
  margenSuperior: any;
  ;
  numResultados: string = '';
  strBuscar: string = '';
  mostrarRecientes: boolean = false;
  segmentSeleccionado: string;
  mostrarModalFiltrosArticulos: boolean = false;

  public pageSize = 15;
  public skip = 0;
  public pageSizes2: PageSizeItem[] = [
    {
      text: "All",
      value: "all",
    },
  ];
  public selectAllState: SelectAllCheckboxState = "unchecked";
  public mySelection: number[] = [];
  public sort: SortDescriptor[] = [
    {
      field: "Fecha",
      dir: "asc",
    },
  ];
  selectedKeysKendo: any[] = [];

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() {
    if (this.variablesGlobales.listaArticulos.length == 0) { this.articulosMostrar = []; this.articulosMostrarKendo = []; }
    addIcons({ funnelOutline, funnel, listOutline, gridOutline,add,closeCircle, refresh, alertCircleOutline, close ,trendingDown, addCircle,swapVertical,options});
  }

  ngOnInit() {
    if(this.variablesGlobales.segmentSeleccionadoArticulos){
      this.segmentSeleccionado = this.variablesGlobales.segmentSeleccionadoArticulos
    }else{
      this.segmentSeleccionado = 'avatar'
    }
    if (this.variablesGlobales?.credencialAcceso?.origen == 'AloSuite'){
      this.margenSuperior = 107;
      this.variablesGlobales.mostrarTabs = false;
    }
    else this.margenSuperior = 0;
    console.log("margen superior ", this.margenSuperior)

    this.cargarCategoriasArticulosALO();
    this.cargarFamiliasArticulosALO();
    this.cargarMarcasArticulosALO();
    this.cargarTarifasPrecioALO();
    this.cargarTarifasDescuentoALO();
    // this.cargarTarifasCompraALO();
    this.cargarTiposIVAALO();
    this.cargarModelosArticulosALO();
    this.cargarTiposRetencionServiciosALO();
    this.translate.use(this.variablesGlobales.idiomaSeleccionado)

    console.log('selectorArticulo: ',this.selectorArticulo);

  }

  ngOnChanges() {
    if (this.articulos) {
      this.articulosCompleto = this.articulos;
      this.articulosFiltrados = this.pipeBuscarFiltrosArticulos.transform(this.articulosCompleto, this.categoriasArticulosSeleccionadas, this.categoriasArticulosSeleccionadas, this.marcasArticulosSeleccionadas)
      this.articulosFiltrados = this.pipeBuscarArticulo.transform(this.pipeBuscarFiltrosArticulos.transform(this.articulosCompleto, this.categoriasArticulosSeleccionadas, this.categoriasArticulosSeleccionadas, this.marcasArticulosSeleccionadas), this.strBuscar, this.articulos)
      this.articulosMostrar = this.articulosFiltrados.slice(0, 25);
      this.articulosMostrarKendo = this.articulosFiltrados.slice(0, 25);
      // this.articulosFiltrados = this.articulos

    } else this.articulos = [];
  }

  cargarCategoriasArticulosALO() {
    this.servicioErp.obtenerCategoriasArticulosAlo(null).toPromise().then(async (resAM: AMRespuestaGET) => {
      if (resAM.status == "200") {
        if (resAM.data.length != 0) {
          resAM.data.forEach((categoria: CategoriaDTO) => {
            let categoriaArticuloSelec: CategoriaSeleccion = { categoriaArticulo: categoria, seleccionada: false };
            this.categoriasArticulos.push(categoriaArticuloSelec)
          })
          console.log('this.categoriasArticulos', this.categoriasArticulos);

          this.variablesGlobales.categoriasArticulos = resAM.data;
        } else {
          this.categoriasArticulos = []
        }
      } else {
        this.categoriasArticulos = []
      }
    })
      .catch(async error => {
        console.error('Error al cargar categorias de articulos de ALO. ERROR: ', error)
        this.categoriasArticulos = []
      })
  }

  cargarFamiliasArticulosALO() {
    this.servicioErp.obtenerFamiliasArticulosAlo(null).toPromise().then(async (resAM: AMRespuestaGET) => {
      if (resAM.status == "200") {
        if (resAM.data.length != 0) {
          resAM.data.forEach((familia: FamiliaArticuloDTO) => {
            let familiaArticuloSelect: FamiliaSeleccion = { familiasArticulos: familia, seleccionada: false };
            this.familiasArticulos.push(familiaArticuloSelect);
          })
          console.log('this.familiasArticulos', this.familiasArticulos);

          this.variablesGlobales.familiasArticulos = resAM.data;
        } else {
          this.familiasArticulos = []
        }
      } else {
        this.familiasArticulos = []
      }
    })
      .catch(async error => {
        console.error('Error al cargar familias de articulos de ALO. ERROR: ', error)
        this.familiasArticulos = []
      })
  }

  cargarMarcasArticulosALO() {
    this.servicioErp.obtenerMarcasArticulosAlo(null).toPromise().then(async (resAM: AMRespuestaGET) => {
      if (resAM.status == "200") {
        if (resAM.data.length != 0) {
          resAM.data.forEach((marca: MarcaDTO) => {
            let marcaArticuloSelect: MarcaSeleccion = { marcaArticulo: marca, seleccionada: false };
            this.marcasArticulos.push(marcaArticuloSelect)
          })

          this.variablesGlobales.marcasArticulos = resAM.data;
          console.log('this.marcasArticulos', this.marcasArticulos);
        } else {
          this.marcasArticulos = []
        }
      } else {
        this.marcasArticulos = []
      }
    })
      .catch(async error => {
        console.error('Error al cargar marcas de articulos de ALO. ERROR: ', error)
        this.marcasArticulos = []
      })
  }

  cargarModelosArticulosALO() {
    this.servicioErp.obtenerModelosArticulosAlo(null).toPromise().then(async (resAM: AMRespuestaGET) => {
      if (resAM.status == "200") {
        if (resAM.data.length != 0) {

          this.variablesGlobales.modelosArticulos = resAM.data;
        }
      }
    })
      .catch(async error => {
        console.error('Error al cargar marcas de articulos de ALO. ERROR: ', error)
      })
  }

  cargarTarifasPrecioALO() {
    this.servicioErp.obtenerTipoTarifaAlo("precios", null).toPromise().then((resAM: AMRespuestaGET) => {
      if (resAM.status == "200") {
        if (resAM.data.length != 0) {
          this.tarifasPrecio = resAM.data as TipoTarifaDTO[];
          console.log('this.tarifasPrecios: ', this.tarifasPrecio);
          this.tarifaPrecioVentaPredeterminada = this.tarifasPrecio.find((tarifaPrecio: TipoTarifaDTO) => (tarifaPrecio.predeterminada == true && tarifaPrecio.tipoOperacion == 0));
          console.log('this.tarifaPrecioPredeterminada: ', this.tarifaPrecioVentaPredeterminada);
          this.tarifaPrecioCompraPredeterminada = this.tarifasPrecio.find((tarifaPrecio: TipoTarifaDTO) => (tarifaPrecio.predeterminada == true && tarifaPrecio.tipoOperacion == 1));
          console.log('this.tarifaPrecioCompraPredeterminada: ', this.tarifaPrecioCompraPredeterminada);

          this.variablesGlobales.tiposTarifasPrecios = this.tarifasPrecio.filter(tf => tf.tipoOperacion == 0);
          this.variablesGlobales.tiposTarifasPreciosCompra = this.tarifasPrecio.filter(tf => tf.tipoOperacion == 1);

        }
      } else {
        this.tarifasPrecio = []
      }
    })
      .catch(async error => {
        console.error('Error al cargar las tarifas de precio de ALO. ERROR: ', error)
        this.tarifasPrecio = []
      })
  }

  // cargarTarifasCompraALO() {
  //   this.servicioErp.obtenerTipoTarifaAlo("precios", null).toPromise().then((resAM: AMRespuestaGET) => {
  //     if (resAM.status == "200") {
  //       if (resAM.data.length != 0) {
  //         this.variablesGlobales.tiposTarifasPreciosCompra = resAM.data;
  //       }
  //     } else {
  //     }
  //   })
  //     .catch(async error => {
  //       console.error('Error al cargar las tarifas de precio de ALO. ERROR: ', error)
  //     })
  // }

  cargarTiposIVAALO() {
    this.servicioErp.obtenerTiposIVAAlo().toPromise().then((resAM: AMRespuestaGET) => {
      if (resAM.status == "200") {
        if (resAM.data.length != 0) {
          this.variablesGlobales.tiposIVA = resAM.data;
        }
      } else {
      }
    })
      .catch(async error => {
        console.error('Error al cargar las tarifas de precio de ALO. ERROR: ', error)
      })
  }

  cargarTiposRetencionServiciosALO() {
    let parametros = {
      claseRenta:"'ACTIVIDADESPROFESIONALES'||'OTRASACTIVIDADES'||'CAPITALINMOBILIARIO'"
    };

    this.servicioErp.obtenerTiposRetencionServiciosAlo(parametros).toPromise().then((resAM: AMRespuestaGET) => {
      if (resAM.status == "200") {
        if (resAM.data.length != 0) {
          this.variablesGlobales.tiposRetencionServicios = resAM.data;
        }
      } else {
      }
    })
      .catch(async error => {
        console.error('Error al cargar las tarifas de precio de ALO. ERROR: ', error)
      })
  }

  cargarTarifasDescuentoALO() {
    this.servicioErp.obtenerTipoTarifaAlo("descuentos", null).toPromise().then((resAM: AMRespuestaGET) => {
      if (resAM.status == "200") {
        if (resAM.data.length != 0) {
          this.tarifasDescuentos = resAM.data
          console.log('this.tarifasDescuentos: ', this.tarifasDescuentos);
          this.tarifaDescuentoPredeterminada = this.tarifasDescuentos.find((tarifasDescuento: TipoTarifaDTO) => tarifasDescuento.predeterminada == true);
          console.log('this.tarifaDescuentoPredeterminada: ', this.tarifaDescuentoPredeterminada);
          this.variablesGlobales.tiposTarifasDescuentos = this.tarifasDescuentos;

        }
      } else {
        this.tarifasDescuentos = []
      }
    })
      .catch(async error => {
        console.error('Error al cargar las tarifas de descuento de ALO. ERROR: ', error)
        this.tarifasDescuentos = []
      })
  }
  cargarMasDatos(event) {
    console.log('Cargar mas datos!');

    if (this.articulosMostrar.length == this.articulosFiltrados.length) {
      console.log('Array cargado completo');
      event.target.complete()
      event.target.disabled = true;
      return;
    }
    let tempArryArticulos: ArticuloDTO[] = this.articulosFiltrados.slice(this.articulosMostrar.length, this.articulosMostrar.length + 25)
    this.articulosMostrar.push(...tempArryArticulos)
    event.target.complete()

  }

  cargarMasDatosKendo(event) {

    console.log('Cargar mas datos kendo!');
    if (this.articulosMostrarKendo.length == this.articulosFiltrados.length) {
      console.log(' Cargar mas datos kendo == length', ' event ', event);
      //event.target.complete()
      //event.target.disabled = true;
      return;
    }
    this.loading = true;
    let tempArryArticulosKendo: ArticuloDTO[] = this.articulosFiltrados.slice(this.articulosMostrarKendo.length, this.articulosMostrarKendo.length + 25)
    this.articulosMostrarKendo.push(...tempArryArticulosKendo)
    console.log(' Cargar mas datos kendo <> lengt', ' event ', event);
    //event.target.complete()
    this.loading = false;

  }




  segmentModificado(event) {
    this.segmentSeleccionado = event.detail.value;
    this.variablesGlobales.segmentSeleccionadoArticulos = this.segmentSeleccionado

  }

  onSearchChange(event) {
    this.strBuscar = event.detail.value

    this.numResultados = '';
    this.articulosFiltrados = this.pipeBuscarArticulo.transform(this.articulos, event.detail.value, this.articulos)
    this.articulosMostrar = this.articulosFiltrados.slice(0, 25);
    this.articulosMostrarKendo = this.articulosFiltrados.slice(0, 25);

    this.numResultados = '(' + this.articulosFiltrados.length + ')';
  }


  async seleccionarArticulo(articulo: ArticuloDTO) {
    //console.log('Articulo seleccionado: ',articulo);
    if (this.variablesGlobales.listaArticulosRecientes.findIndex((articulos) => articulos.id == articulo.id) === -1) {
      console.log("Añado el articulo a recientes!");
      let articuloEnciptado = this.servicioEncriptar.encriptar(JSON.stringify(articulo))
      db.guardarArticulosRecientesDB(articuloEnciptado)
      this.variablesGlobales.listaArticulosRecientes.unshift(articulo) //Se utiliza unshift para añadir el elmemento en la primera posición del array
    }

    if(this.selectorArticulo){
      this.anadirAlCarrito(articulo)
    }else{
      let modal: HTMLIonModalElement
      if (this.variablesGlobales.plataforma == 'movil') {
        modal = await this.modalCtrl.create({
          component: (await import('../info-articulo/info-articulo.component')).InfoArticuloComponent,
          breakpoints: [0, 0.5, 1],
          initialBreakpoint: 0.5,
          mode: 'ios',
          componentProps: {
            articulo: articulo,
            //articulosArray:this.articulos
          }
        });
      } else {
        modal = await this.modalCtrl.create({
          component: (await import('../info-articulo/info-articulo.component')).InfoArticuloComponent,
          mode: 'ios',
          componentProps: {
            articulo: articulo,
            //articulosArray:this.articulos
          }
        });
      }
      modal.onDidDismiss()
        .then((data) => {
          if (data.data) {
            const articulo: ArticuloDTO = data['data'];
            console.log('articulo a añadir: ', articulo);
            this.anadirAlCarrito(articulo)

          }
        });

      await modal.present();

      modal.onWillDismiss().then(() => {
        this.selectedKeysKendo = [];
      })
    }
  }

  seleccionadaCategoria(categoriaSelec: CategoriaSeleccion) {
    //console.log('SeleccionadaCategoria: ',categoriaSelec);
    categoriaSelec.seleccionada = !categoriaSelec.seleccionada
    this.actualizarListaFiltros()

  }

  seleccionadaFamilia(familiaSelec: FamiliaSeleccion) {
    //console.log('SeleccionadaFamilia: ',familiaSelec);
    familiaSelec.seleccionada = !familiaSelec.seleccionada
    this.actualizarListaFiltros()
  }

  seleccionadaMarca(marcaSelec: MarcaSeleccion) {
    //console.log('SeleccionadaMarca: ',marcaSelec);
    marcaSelec.seleccionada = !marcaSelec.seleccionada
    this.actualizarListaFiltros()
  }

  actualizarListaFiltros() {
    this.numFiltros = 0;
    if (this.mostrarRecientes) {
      this.numFiltros++;
    }
    this.categoriasArticulosSeleccionadas = []
    this.categoriasArticulos.forEach((categoria: CategoriaSeleccion) => {
      if (categoria.seleccionada) {
        this.categoriasArticulosSeleccionadas.push(categoria.categoriaArticulo)
        this.numFiltros++;
      }
    })

    this.familiasArticulosSeleccionadas = []
    this.familiasArticulos.forEach((familia: FamiliaSeleccion) => {
      if (familia.seleccionada) {
        this.familiasArticulosSeleccionadas.push(familia.familiasArticulos)
        this.numFiltros++;
      }
    })

    this.marcasArticulosSeleccionadas = []
    this.marcasArticulos.forEach((marca: MarcaSeleccion) => {
      if (marca.seleccionada) {
        this.marcasArticulosSeleccionadas.push(marca.marcaArticulo)
        this.numFiltros++;
      }
    })

    this.articulosFiltrados = this.pipeBuscarFiltrosArticulos.transform(this.articulos, this.categoriasArticulosSeleccionadas, this.familiasArticulosSeleccionadas, this.marcasArticulosSeleccionadas)

    //this.articulosFiltrados = this.pipeBuscarArticulo.transform(this.articulosFiltrados, this.strBuscar, this.articulos)
    this.articulosMostrar = this.articulosFiltrados.slice(0, 25);
    this.articulosMostrarKendo = this.articulosFiltrados.slice(0, 25);

    this.infiniteScroll.disabled = false
    if (this.numFiltros == 0) {
      this.numResultados = '';
    } else {
      //this.numResultados = '('+this.articulosFiltrados.length+')';
      this.numResultados = '(' + this.articulosFiltrados.length + ')';

    }


  }

  btnQuitarFiltros() {
    this.categoriasArticulos.forEach((categoria: CategoriaSeleccion) => {
      if (categoria.seleccionada) {
        categoria.seleccionada = false
      }
    })

    this.familiasArticulos.forEach((familia: FamiliaSeleccion) => {
      if (familia.seleccionada) {
        familia.seleccionada = false
      }
    })

    this.marcasArticulos.forEach((marca: MarcaSeleccion) => {
      if (marca.seleccionada) {
        marca.seleccionada = false
      }
    })
    this.categoriasArticulosSeleccionadas = [];
    this.familiasArticulosSeleccionadas = [];
    this.marcasArticulosSeleccionadas = [];
    this.numFiltros = 0;

    this.articulosFiltrados = this.pipeBuscarFiltrosArticulos.transform(this.articulos, this.categoriasArticulosSeleccionadas, this.familiasArticulosSeleccionadas, this.marcasArticulosSeleccionadas)
    this.articulosMostrar = this.articulosFiltrados.slice(0, 50);
    this.articulosMostrarKendo = this.articulosFiltrados.slice(0, 25);
    if (this.strBuscar = '') {
      this.numResultados = '';
    } else {
      this.numResultados = '(' + this.articulosFiltrados.length + ')';
    }
    this.infiniteScroll.disabled = false
  }

  async anadirAlCarrito(articulo: ArticuloDTO, slidingItem?) {
    let loading
    await this.translate.get('alert.cargandoInfoArticulo').subscribe(async (alertStr: string) => {
      loading = await this.loadingCtrl.create({
        message: this.titlecasePipe.transform(alertStr),
      });
      loading.present();
    })
    await this.servicioErp.obtenerArticuloAlo(enumNivelDetalle.AVANZADO, articulo.id).toPromise().then(async (resAM: AMRespuestaGET) => {
      if (resAM.status == "200") {
        if (resAM.data.length != 0) {
          console.log('Información completa articulo ALO: ', resAM.data)
          loading.dismiss(resAM.data);
          articulo = resAM.data[0]
        } else {
          loading.dismiss();
        }
      } else {
        console.error('Error al cargar articulo de ALO. Status: ', resAM.status, ' message: ', resAM.message)
        loading.dismiss();
      }
    })
      .catch(async error => {
        console.error('Error al cargar articulo de ALO. ERROR: ', error)
        loading.dismiss();
      })

    if (slidingItem) {
      slidingItem.close();
    }

    if (!this.variablesGlobales.documentoEnCurso) {

      let modalCrearDocumento
      if (this.variablesGlobales.plataforma == 'movil') {
        modalCrearDocumento = await this.modalCtrl.create({
          component: (await import('src/app/components/modal-crear-documento/modal-crear-documento.component')).ModalCrearDocumentoComponent,
          mode: 'ios',
          cssClass: 'modalCrearDocumento',
          id: 'modalCrearDocumento',
          componentProps: {
            articuloSeleccionado: articulo,
            tarifaPrecioVentaPredeterminada: this.tarifaPrecioVentaPredeterminada,
            tarifaPrecioCompraPredeterminada: this.tarifaPrecioCompraPredeterminada,
            tarifaDescuentoPredeterminada: this.tarifaDescuentoPredeterminada

          }
        });
      } else {
        modalCrearDocumento = await this.modalCtrl.create({
          component: (await import('src/app/components/modal-crear-documento/modal-crear-documento.component')).ModalCrearDocumentoComponent,
          mode: 'ios',
          id: 'modalCrearDocumento',
          componentProps: {
            articuloSeleccionado: articulo,
            tarifaPrecioVentaPredeterminada: this.tarifaPrecioVentaPredeterminada,
            tarifaPrecioCompraPredeterminada: this.tarifaPrecioCompraPredeterminada,
            tarifaDescuentoPredeterminada: this.tarifaDescuentoPredeterminada
          }
        });
      }
      await modalCrearDocumento.present();
      modalCrearDocumento.onDidDismiss().then(data => {
        console.log('Cerrado modal crear documento');

      })

    } else {
      let modal = await this.modalCtrl.create({
        component: (await import('../input-unidades/input-unidades.component')).InputUnidadesComponent,
        mode: 'ios',
        cssClass: 'modalInputUnidades',
        componentProps: {
          articulo: articulo,
          tipoDocumento: this.variablesGlobales.documentoActual.tipo,
          modalidadFactura: this.variablesGlobales.documentoActual.modalidadFactura
        }
      });

      await modal.present();
      modal.onDidDismiss().then(async data => {
        if (data.data) {
          console.log('NumUnidades: ', data);
          if(this.variablesGlobales.documentoActual.tipoOperacion == eTipoGrupo.CL){
            if(this.variablesGlobales.documentoActual.documentoALO!=null){//Es una edición, ya tiene los tarifas  de precios y descuentos
              await this.procesosGlobales.anadirAlCarrito(articulo, data, this.variablesGlobales.documentoActual.tarifaPrecioPredeterminada, this.variablesGlobales.documentoActual.tarifaDescuentoPredeterminada);
            }else{
              await this.procesosGlobales.anadirAlCarrito(articulo, data,this.tarifaPrecioVentaPredeterminada, this.tarifaDescuentoPredeterminada);
            }
          }else if (this.variablesGlobales.documentoActual.tipoOperacion == eTipoGrupo.PR){
            if(this.variablesGlobales.documentoActual.documentoALO!=null){//Es una edición, ya tiene los tarifas  de precios y descuentos
              await this.procesosGlobales.anadirAlCarrito(articulo, data, this.variablesGlobales.documentoActual.tarifaPrecioPredeterminada, this.variablesGlobales.documentoActual.tarifaDescuentoPredeterminada);
            }else{
              await this.procesosGlobales.anadirAlCarrito(articulo, data,this.tarifaPrecioCompraPredeterminada, this.tarifaDescuentoPredeterminada);
            }
          }
          this.servicioEncriptar.guardarEnStorage('documentoActual', JSON.stringify(this.variablesGlobales.documentoActual));
          if(this.selectorArticulo){
            this.articuloSeleccionado.emit(articulo)
          }
        }




      })
    }


  }

  obtenerTarifaPrecioArticuloPredeterminado(articulo: ArticuloDTO): TarifaPreciosDTO {
    //console.log('precioPredeterminado: Articulo ',articulo);

    let arrayPreciosPredeterminados: TarifaPreciosDTO[] = []
    arrayPreciosPredeterminados = articulo?.preciosGenerales?.filter((precioGeneral: TarifaPreciosDTO) => precioGeneral?.entidad?.id == this.tarifaPrecioVentaPredeterminada?.id)

    if (arrayPreciosPredeterminados != null && arrayPreciosPredeterminados.length > 0) {
      let fechaActual: Date = new Date();
      // console.log('Fecha Actual: ',fechaActual);
      // for (let index = 0; index < arrayPreciosPredeterminados.length; index++) {
      //   let fechaInicial: Date = new Date(arrayPreciosPredeterminados[index].fechaInicial)
      //   let fechaFinal: Date = new Date(arrayPreciosPredeterminados[index].fechaFinal)
      //   console.log({fechaInicial});
      //   console.log({fechaFinal});
      // }
      arrayPreciosPredeterminados = arrayPreciosPredeterminados.filter((precioGeneral: TarifaPreciosDTO) => (fechaActual >= new Date(precioGeneral.fechaInicial)) && (fechaActual <= new Date(precioGeneral.fechaFinal)))
      arrayPreciosPredeterminados = arrayPreciosPredeterminados.sort(function (a, b) { return (new Date(a.fechaInicial) < new Date(b.fechaInicial)) ? 1 : ((new Date(b.fechaInicial) < new Date(a.fechaInicial)) ? -1 : 0) })

      let precioPredeterminado = arrayPreciosPredeterminados[0]
      // console.log('precioPredeterminado: precios',precioPredeterminado);
      return precioPredeterminado
    }

  }

  obtenerTarifaDescuentoArticuloPredeterminado(articulo: ArticuloDTO): TarifaDescuentosDTO {
    let descuentoPredeterminado: any = null
    descuentoPredeterminado = articulo?.descuentosGenerales?.find((descuentoGeneral: TarifaDescuentosDTO) => descuentoGeneral?.entidad?.id == this.tarifaDescuentoPredeterminada?.id)
    return descuentoPredeterminado
  }

  toogleRecientesCambiado(event) {
    console.log({ event });
    this.mostrarRecientes = event.detail.checked
    console.log('this.mostrarRecientes: ', this.mostrarRecientes);

    if (this.mostrarRecientes) {
      console.log("Muestro solo recientes!");
      this.articulos = this.variablesGlobales.listaArticulosRecientes;
      this.articulosMostrar = this.articulos.slice(0, 25);
      this.articulosMostrarKendo = this.articulos.slice(0, 25)
      this.articulosFiltrados = this.articulos
      this.actualizarListaFiltros();
    } else {
      this.articulos = this.articulosCompleto
      this.articulosMostrar = this.articulos.slice(0, 25);
      this.articulosMostrarKendo = this.articulos.slice(0, 25)

      this.articulosFiltrados = this.articulos
      this.actualizarListaFiltros();
    }
  }
  cambiarVista() {
    this.variablesGlobales.vistaGrid = !this.variablesGlobales.vistaGrid
  }

  onSelectedKeysChange($event) {
    console.log("SelectedKeysChange ", $event)
  }

  sortChange(ev: any) {

  }

  public pageChange({ skip, take }: PageChangeEvent): void {
    this.skip = skip;
    this.pageSize = take;
    this.loadItems();

    //this.loadItems();
    // this.grid.autoFitColumns();
    // Optionally, clear the selection when paging
    // this.mySelection = [];
  }

  private loadItems(): void {
    console.log('grid loadItens() ')
    if (this.articulos) {
      this.variablesGlobales.gridView = {
        data: this.articulos.slice(this.skip, this.skip + this.pageSize),
        total: this.articulos.length,
      };
    }
    // this.grid.autoFitColumns();


  }

  refresherListaArticulos(event?) {
    if (event) {
      event.target.complete();
    }
    this.numFiltros = 0;
    this.categoriasArticulosSeleccionadas = []
    this.familiasArticulosSeleccionadas = []
    this.marcasArticulosSeleccionadas = []
    this.actualizarListaArticulos.emit()
  }





}
